// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const SignalOriginSchema = z.enum(['HTTP_ANALYSIS','SOURCE_CODE_ANALYSIS','CODE_TRACKING_ANALYSIS','AGENTIC_CODE_TRACKING_ANALYSIS','CVE_ANALYSIS','CVE_DATABASE','CO_PILOT','MANUAL','EXTERNAL_INTEGRATION','EXTERNAL_NETWORK_DISCOVERY','ACTIVE_SCAN','DYNAMIC_SCAN','FINDING_CHAINING','SCANNER_IMPORT','MCP_ANALYSIS','MISCONFIGURATION_RESEARCHER','AGENT_GRAPH_ANALYSIS','AGENT_EXCHANGE_ANALYSIS','ACTIVE_PROBE','DEEP_SECURITY_SOURCE_CODE_ANALYSIS'] as const);

export type SignalOriginType = `${z.infer<typeof SignalOriginSchema>}`

export default SignalOriginSchema;
